<div class="flex-column gap p-2">
    <app-select-input
        [infiniteScroll]="diagnosisScroll()"
        [form]="form"
        id="diagnosisCodeId"
        [label]="prefix + 'fields.code.label'"
        valueKey="id"
        filterBy="groupName,code,title"
        [showClear]="false"
    >
        <ng-template #item let-item>
            <div class="flex gap-small">
                <div>{{ item.code }}</div>
                <div>{{ item.title }}</div>
            </div>
        </ng-template>

        <ng-template #selectedItem let-item>
            <div class="flex gap-small">
                <div>{{ item.code }}</div>
                <div>{{ item.title }}</div>
            </div>
        </ng-template>
    </app-select-input>

    @if (selectedCode()) {
        <p-accordion>
            @if (selectedCode()?.symptoms?.length) {
                <p-accordion-panel value="symptoms">
                    <p-accordion-header>{{ prefix + 'fields.symptoms.label' | translate }}</p-accordion-header>
                    <p-accordion-content>
                        <div class="flex-column gap overflow-visible">
                            <app-input-wysiwyg
                                [form]="form"
                                [height]="250"
                                id="symptomsComment"
                                editorKey="NursingCareDiagnosisDialogSymptoms"
                                [autocompleteOrganization]="true"
                            ></app-input-wysiwyg>

                            <app-multi-select-input
                                [label]="prefix + 'fields.symptoms.label'"
                                [staticOptions]="selectedCode()?.symptoms || []"
                                valueKey="id"
                                labelKey="title"
                                [form]="form" id="symptoms"
                                [zIndex]="10005"
                            ></app-multi-select-input>
                        </div>
                    </p-accordion-content>
                </p-accordion-panel>
            }

            @if (selectedCode()?.factors?.length) {
                <p-accordion-panel value="factors">
                    <p-accordion-header>{{ 'folder.voucher.nursingCarePlan.createDiagnosis.fields.factors.label' | translate }}</p-accordion-header>
                    <p-accordion-content>
                        <div class="flex-column gap overflow-visible">
                            <app-input-wysiwyg
                                [form]="form"
                                [height]="250"
                                id="factorsComment"
                                editorKey="NursingCareDiagnosisDialogFactors"
                                [autocompleteOrganization]="true"
                            ></app-input-wysiwyg>

                            <app-multi-select-input
                                [label]="prefix + 'fields.factors.label'"
                                [staticOptions]="selectedCode()?.factors || []"
                                valueKey="id"
                                labelKey="title"
                                [form]="form" id="factors"
                                [zIndex]="10005"
                            ></app-multi-select-input>
                        </div>
                    </p-accordion-content>
                </p-accordion-panel>
            }

            @if (selectedCode()?.riskFactors?.length) {
                <p-accordion-panel value="riskFactors">
                    <p-accordion-header>{{ 'folder.voucher.nursingCarePlan.createDiagnosis.fields.riskFactors.label' | translate }}</p-accordion-header>
                    <p-accordion-content>
                        <div class="flex-column gap overflow-visible">
                            <app-input-wysiwyg
                                [form]="form"
                                [height]="250"
                                id="riskFactorsComment"
                                editorKey="NursingCareDiagnosisDialogRiskFactors"
                                [autocompleteOrganization]="true"
                            ></app-input-wysiwyg>

                            <app-multi-select-input
                                [label]="prefix + 'fields.riskFactors.label'"
                                [staticOptions]="selectedCode()?.riskFactors || []"
                                valueKey="id"
                                labelKey="title"
                                [form]="form" id="riskFactors"
                                [zIndex]="10005"
                            ></app-multi-select-input>
                        </div>
                    </p-accordion-content>
                </p-accordion-panel>
            }

            @if (selectedCode()?.goals?.length) {
                <p-accordion-panel value="goals">
                    <p-accordion-header>{{ 'folder.voucher.nursingCarePlan.createDiagnosis.fields.goals.label' | translate }}</p-accordion-header>
                    <p-accordion-content>
                        <div class="flex-column gap overflow-visible">
                            <app-input-wysiwyg
                                [form]="form"
                                [height]="250"
                                id="goalsComment"
                                editorKey="NursingCareDiagnosisDialogGoals"
                                [autocompleteOrganization]="true"
                            ></app-input-wysiwyg>

                            <app-multi-select-input
                                [label]="prefix + 'fields.goals.label'"
                                [staticOptions]="selectedCode()?.goals || []"
                                valueKey="id"
                                labelKey="title"
                                [form]="form"
                                id="goals"
                                [zIndex]="10005"
                            ></app-multi-select-input>
                        </div>
                    </p-accordion-content>
                </p-accordion-panel>
            }

            @if (selectedCode()?.interventions?.length) {
                <p-accordion-panel value="interventions">
                    <p-accordion-header>{{ 'folder.voucher.nursingCarePlan.createDiagnosis.fields.interventions.label' | translate }}</p-accordion-header>
                    <p-accordion-content>
                        <div class="flex-column gap overflow-visible">
                            <app-input-wysiwyg
                                [form]="form"
                                [height]="250"
                                id="interventionsComment"
                                editorKey="NursingCareDiagnosisDialogInterventions"
                                [autocompleteOrganization]="true"
                            ></app-input-wysiwyg>

                            <app-multi-select-input
                                [label]="prefix + 'fields.interventions.label'"
                                [staticOptions]="selectedCode()?.interventions || []"
                                valueKey="id"
                                labelKey="title"
                                [form]="form" id="interventions"
                                [zIndex]="10005"
                            ></app-multi-select-input>
                        </div>
                    </p-accordion-content>
                </p-accordion-panel>
            }
        </p-accordion>
    }
</div>
